import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FacetsService } from '../services';

import { ArticleSearchFacetsActions, StartPageFacetsActions } from './facets.actions';

@Injectable()
export class FacetsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly facetsService: FacetsService,
  ) {}

  articleSearchFetchFacetsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ArticleSearchFacetsActions.fetchFacets),
      switchMap(({ request }) => {
        return this.facetsService.fetchFacets(request).pipe(
          map((facets) => ArticleSearchFacetsActions.fetchFacetsSuccess({ facets })),
          catchError(() => of(ArticleSearchFacetsActions.fetchFacetsError())),
        );
      }),
    );
  });

  startPageFetchFacetsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StartPageFacetsActions.fetchFacets),
      switchMap(({ request }) => {
        return this.facetsService.fetchFacets(request).pipe(
          map((facets) => StartPageFacetsActions.fetchFacetsSuccess({ facets })),
          catchError(() => of(StartPageFacetsActions.fetchFacetsError())),
        );
      }),
    );
  });

  articleSearchFetchDrilldownFacetEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ArticleSearchFacetsActions.fetchDrilldownFacet),
      switchMap(({ request }) => {
        return this.facetsService.fetchFacetDrilldown(request).pipe(
          map((facet) =>
            ArticleSearchFacetsActions.fetchDrilldownFacetSuccess({
              facetType: request.facetType,
              facet,
            }),
          ),
          catchError(() => of(ArticleSearchFacetsActions.fetchDrilldownFacetError())),
        );
      }),
    );
  });
}
